

const capabilities =()=>(
    <div className="flex flex-col sm:mb-10 mb-24 mt-10 items-center">
        <h1 className="sm:text-2xl text-lg w-[70vw] sm:w-full text-center mb-10 mt-2">Our connection, innovation, and intelligence make PayPal your stratergic partner </h1>
        <div className="flex items-center w-full justify-center flex-wrap sm:flex-nowrap">
            <div className="flex flex-col items-center m-5 rounded-md w-72 sm:mr-24 sm:ml-10">
                <img src="https://png.pngtree.com/background/20230525/original/pngtree-the-world-s-network-of-connections-and-connections-in-a-blue-picture-image_2727423.jpg"
                alt="capability" className="size-20  filter saturate-200"/>
                <div className="text-center">
                    <h1 className="lg:text-2xl text-xl">
                        Connected
                    </h1>
                    <p className="text-sm">PayPal is a single point of entry to payments expertise, tool, technology, and data that can help you complete and win</p>
                </div>
            </div>
            <div  className="flex flex-col items-center w-72 sm:mr-24">
                <img src="
https://t4.ftcdn.net/jpg/02/91/54/61/240_F_291546127_Q6o06XzSKWKHyMo6JlkAEc6K94A6GAHX.jpg"
                alt="capability" className="size-20   filter saturate-200"/>
                <div className="text-center">
                    <h1 className="lg:text-2xl text-xl">
                        Innovative
                    </h1>
                    <p className="text-sm">PayPal is a single point of entry to payments expertise, tool, technology, and data that can help you complete and win</p>
                </div>
            </div>
            <div  className="flex flex-col items-center w-72 sm:mr-24">
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQBRm9b6mR9IoTEvNJoKgL1CUHtFi0MzZrqPqRDxibTUTr97K9nT-er8ZAj_IABaUiHCWY&usqp=CAU"
                alt="capability" className="size-20 rounded-md  filter saturate-200"/>
                <div className="text-center">
                    <h1 className="lg:text-2xl text-xl">
                        Intelligent
                    </h1>
                    <p className="text-sm">PayPal is a single point of entry to payments expertise, tool, technology, and data that can help you complete and win</p>
                </div>
            </div>
            </div>   
    </div>
)


export default capabilities